<template>
  <v-container fluid>
    <v-card>
      <v-row dense>
        <v-col cols="12" sm="2">
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Фильтр"
              outlined
              dense
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" sm="2" align-self="center">
          <v-autocomplete
            :items="users"
            v-model="userTarget"
            item-text="fullName"
            item-value="id"
            label="Пользователи"
            outlined
            dense
            hide-details
            clearable
          />
        </v-col>
        <v-col cols="12" sm="2" align-self="center">
          <v-menu v-model="dateFromMenu">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFromTarget"
                v-bind="attrs"
                v-on="on"
                label="за период с"
                dense
                hide-details
                outlined
                clearable
                autocomplete="off"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dateFromTarget" no-title scrollable>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="2" align-self="center">
          <v-menu v-model="dateToMenu">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateToTarget"
                v-bind="attrs"
                v-on="on"
                label="по"
                dense
                hide-details
                outlined
                clearable
                autocomplete="off"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dateToTarget" no-title scrollable>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="2" align-self="center" class="mr-3">
          <v-btn
            type="button"
            color="info"
            @click="logExcel"
            :disabled="userTarget == null && !dateFromTarget && !dateToTarget"
            >Сформировать отчет
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="logs"
        :search="search"
        :items-per-page="10"
        dense
        hide-default-footer
      >
        <template v-slot:footer>
          <v-pagination
            v-model="page"
            :length="page + 1"
            :total-visible="7"
            circle
          ></v-pagination
        ></template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Обновить</v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import Vue from "vue";
import { URL_API } from "../settings/apiConnect";
import { mapActions } from "vuex";

export default {
  name: "ActionLogTab",
  data: () => ({
    page: 1,
    search: "",
    headers: [
      {
        text: "ID",
        align: "center",
        sortable: true,
        value: "id"
      },
      {
        text: "ФИО пользователя",
        align: "center",
        sortable: false,
        value: "fullName"
      },
      {
        text: "Роль пользователя",
        align: "center",
        sortable: false,
        value: "role"
      },
      {
        text: "Тип действий",
        align: "center",
        sortable: false,
        value: "type"
      },
      {
        text: "Действия",
        align: "center",
        sortable: false,
        value: "message"
      },
      {
        text: "Дата создания",
        align: "center",
        sortable: true,
        value: "created_at"
      },
      {
        text: "Дата обновления",
        align: "center",
        sortable: true,
        value: "updated_at"
      }
    ],
    userTarget: null,
    dateFromMenu: false,
    dateFromTarget: "",
    dateToMenu: false,
    dateToTarget: ""
  }),

  watch: {
    page(page) {
      this.getEventLog(page);
    }
  },

  computed: {
    logs() {
      let arr = [];
      if (Object.keys(this.$store.state.eventLog.eventLogData).length === 0)
        return arr;
      this.$store.state.eventLog.eventLogData.forEach(el => {
        return arr.push({
          id: el.id,
          fullName:
            el.user.surname + " " + el.user.name + " " + el.user.patronym,
          role: el.user.roles ? el.user.roles[0].name : "",
          type: el.type,
          message: el.message,
          created_at: el.created_at,
          updated_at: el.updated_at
        });
      });
      return arr;
    },
    users() {
      let arr = [];
      if (Object.keys(this.$store.state.users.logUsers).length === 0)
        return arr;
      this.$store.state.users.logUsers.forEach(e => {
        return arr.push({
          id: e.id,
          fullName:
            e.surname + " " + e.name + " " + (e.patronym ? e.patronym : "")
        });
      });
      return arr;
    }
  },

  methods: {
    ...mapActions(["getEventLog"]),
    initialize() {
      this.getEventLog();
    },
    logExcel() {
      let userId = "";
      if (this.userTarget) userId = `&user_id=${this.userTarget}`;
      let dateFrom = "";
      if (this.dateFromTarget) dateFrom = `&date_from=${this.dateFromTarget}`;
      let dateTo = "";
      if (this.dateToTarget) dateTo = `&date_to=${this.dateToTarget}`;

      Vue.axios({
        url: `${URL_API}event-log/export-excel?${userId}${dateFrom}${dateTo}`,
        method: "GET",
        responseType: "blob"
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "logFile.xlsx");
        document.body.appendChild(link);
        link.click();
      });
      this.userTarget = null;
      this.dateFromTarget = this.dateToTarget = "";
    }
  }
};
</script>

<style scoped></style>
